


export const ChatMessage = ({classType,className,message,timestamp})=>(
    <div
    className={` ${classType}  ${className} `}
  >
    <div className="message-content">{message}</div>
    <div className="message-timestamp">{timestamp}</div>
  </div>
);